import util from '../libs/util'

/**
 * 配置静态路由
 * 分为两种路由：
 * 1.路由出口在App.vue
 * 2.路由出口在main.vue
 * 注意：为避免不必要的错误，每个路由需设置name属性！！！
 * 注意：为避免不必要的错误，每个路由需设置name属性！！！
 * 注意：为避免不必要的错误，每个路由需设置name属性！！！
 */
// 1.路由出口在App.vue
const singleRoutes = [
  {
    // 设置初始页面
    path: '',
    redirect: '/login'
  },
  {
    path: '/index',
    name: 'index',
    component: () => import('../views/index/index.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/login/login.vue')
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('../views/login/register.vue')
  },
  {
    path: '/forgetPassword',
    name: 'forgetPassword',
    component: () => import('../views/login/forgetPassword.vue')
  },
  {
    path: '/404',
    name: '404',
    component: () => import('../views/error-pages/404.vue')
  },
  {
    path: '/roast',
    name: 'roast',
    title: '吐槽',
    icon: 'ios-paper',
    type: 'menu',
    component: () => import('../views/home/homeroast.vue'),
    children: [
      {
        path: '/roast/index',
        name: 'roast',
        title: '首页',
        icon: 'ios-paper',
        type: 'menu',
        component: () => import('../views/roast/index.vue')
      },
      {
        path: '/roast/roast',
        name: 'roast',
        title: '吐槽',
        icon: 'ios-paper',
        type: 'menu',
        component: () => import('../views/roast/roast.vue')
      },
      {
        path: '/roast/roastall',
        name: 'roast',
        title: '查看全部吐槽',
        icon: 'ios-paper',
        type: 'menu',
        component: () => import('../views/roast/roastall.vue')
      },
      {
        path: '/roast/addroast',
        name: 'roast',
        title: '新增吐槽',
        icon: 'ios-paper',
        type: 'menu',
        component: () => import('../views/roast/addroast.vue')
      },

    ]
  },
]

/**
 * 路由出口在main.vue，包括了菜单项和非菜单页面
 * 若该页面属于菜单页面，需要添加type: 'menu'属性
 */
const staticTree = [
  {
    path: '/managementDepartment',
    name: 'managementDepartment',
    title: '厂站管理',
    icon: 'ios-paper',
    type: 'menu',
    component: () => import('../views/home/homePage.vue'),
    children: [
      {
        path: '/managementDepartment',
        name: 'managementDepartment',
        title: '厂站管理',
        icon: 'ios-paper',
        type: 'menu',
        component: () => import('../views/examineAdministration/managementDepartment.vue')
      }
    ]
  },
  {
    path: '/managementEmployee',
    name: 'managementEmployee',
    title: '员工管理',
    icon: 'ios-paper',
    type: 'menu',
    component: () => import('../views/home/homePage.vue'),
    children: [
      {
        path: '/roster',
        name: 'roster',
        title: '花名册',
        icon: 'ios-paper',
        type: 'menu',
        component: () => import('../views/examineAdministration/roster.vue')
      },

    ]
  },
  {
    path: '/homePage',
    name: 'homePage',
    title: '首页',
    icon: 'ios-paper',
    type: 'menu',
    component: () => import('../views/home/homePage.vue'),
    children: [
      {
        path: '/homeContent',
        name: 'homeContent',
        title: '首页',
        icon: 'ios-paper',
        type: 'menu',
        component: () => import('../views/home/homeContent.vue'),
        children: [
          {
            path: '/personal',
            name: 'personal',
            title: '个人资料',
            type: 'menu',
            component: () => import('../views/home/personal.vue')
          },
          {
            path: '/password',
            name: 'password',
            title: '修改密码',
            type: 'menu',
            component: () => import('../views/home/password.vue')
          },
          {
            path: '/addEnterprise',
            name: 'addEnterprise',
            title: '创建/加入企业',
            type: 'menu',
            component: () => import('../views/home/addEnterprise.vue')
          },
          {
            path: '/companyApplyEdit',
            name: 'companyApplyEdit',
            title: '编辑企业',
            type: 'menu',
            component: () => import('../views/organization/companyApplyEdit.vue')
          }
        ]
      },
    ]
  },
  {
    path: '/authority',
    name: 'authority',
    title: '系统权限管理',
    icon: 'ios-paper',
    type: 'menu',
    component: () => import('../views/home/homePage.vue'),
    children: [
      {
        path: '/authority/routers',
        name: 'routers',
        title: '菜单管理',
        icon: 'ios-paper',
        type: 'menu',
        component: () => import('../views/authority/routers.vue')
      },
      {
        path: '/authority/role',
        name: 'role',
        title: '角色管理',
        icon: 'ios-paper',
        type: 'menu',
        component: () => import('../views/authority/role.vue'),
        children: [
          {
            path: '/authority/role/roleAdd',
            name: 'roleAdd',
            title: '新增',
            icon: 'ios-paper',
            type: 'menu',
            component: () => import('../views/authority/roleAdd.vue')
          },
          {
            path: '/authority/role/roleEdit',
            name: 'roleEdit',
            title: '编辑',
            icon: 'ios-paper',
            type: 'menu',
            component: () => import('../views/authority/roleEdit.vue')
          },
          {
            path: '/authority/role/roleAuthority',
            name: 'roleAuthority',
            title: '权限配置',
            icon: 'ios-paper',
            type: 'menu',
            component: () => import('../views/authority/roleAuthority.vue')
          }
        ]
      },
      {
        path: '/authority/admin',
        name: 'admin',
        title: '用户账号管理',
        icon: 'ios-paper',
        type: 'menu',
        component: () => import('../views/authority/admin.vue'),
        children: [
          {
            path: '/authority/admin/adminAdd',
            name: 'adminAdd',
            title: '新增',
            icon: 'ios-paper',
            type: 'menu',
            component: () => import('../views/authority/adminAdd.vue')
          },
          {
            path: '/authority/admin/adminEdit',
            name: 'adminEdit',
            title: '编辑',
            icon: 'ios-paper',
            type: 'menu',
            component: () => import('../views/authority/adminEdit.vue')
          },
          {
            path: '/authority/admin/adminPassword',
            name: 'adminPassword',
            title: '重置密码',
            icon: 'ios-paper',
            type: 'menu',
            component: () => import('../views/authority/adminPassword.vue')
          }
        ]
      },
      {
        path: '/authority/loginLog',
        name: 'loginLog',
        title: '登录日志',
        icon: 'ios-paper',
        type: 'menu',
        component: () => import('../views/authority/loginLog.vue')
      },
      {
        path: '/authority/operLog',
        name: 'operLog',
        title: '操作日志',
        icon: 'ios-paper',
        type: 'menu',
        component: () => import('../views/authority/operLog.vue')
      },
      {
        path: '/authority/dic',
        name: 'dic',
        title: '字典管理',
        icon: 'ios-paper',
        type: 'menu',
        component: () => import('../views/authority/dic.vue'),
        children: [
          {
            path: '/authority/dic/dicAdd',
            name: 'dicEdit',
            title: '新增',
            icon: 'ios-paper',
            type: 'menu',
            component: () => import('../views/authority/dicAdd.vue')
          },
          {
            path: '/authority/dic/dicEdit',
            name: 'dicEdit',
            title: '编辑',
            icon: 'ios-paper',
            type: 'menu',
            component: () => import('../views/authority/dicEdit.vue')
          }
        ]
      }
    ]
  },
  {
    path: '/companyEvaluation',
    name: 'companyEvaluation',
    title: '考评管理',
    icon: 'ios-paper',
    type: 'menu',
    component: () => import('../views/home/homePage.vue'),
    children: [
      {
        path: '/companyEvaluation/companyEvaluation',
        name: 'companyEvaluation',
        title: '考评管理',
        icon: 'ios-paper',
        type: 'menu',
        component: () => import('../views/companyEvaluation/companyEvaluation.vue')
      },
    ]
  },
  {
    path: '/foreignEmployees',
    name: 'foreignEmployees',
    title: '外籍雇员管理',
    icon: 'ios-paper',
    type: 'menu',
    component: () => import('../views/home/homePage.vue'),
    children: [
      {
        path: '/foreignEmployees/foreignEmployees',
        name: 'foreignEmployees',
        title: '外籍雇员管理',
        icon: 'ios-paper',
        type: 'menu',
        component: () => import('../views/foreignEmployees/foreignEmployees.vue')
      },
      {
        path: '/foreignEmployees/handle',
        name: 'handle',
        title: '证件临期处理',
        icon: 'ios-paper',
        type: 'menu',
        component: () => import('../views/foreignEmployees/handle.vue')
      }
    ]
  },
  {
    path: '/companyAttendance',
    name: 'companyAttendance',
    title: '外籍雇员管理',
    icon: 'ios-paper',
    type: 'menu',
    component: () => import('../views/home/homePage.vue'),
    children: [
      {
        path: '/companyAttendance/companyAttendance',
        name: 'companyAttendance',
        title: '外籍雇员管理',
        icon: 'ios-paper',
        type: 'menu',
        component: () => import('../views/companyAttendance/companyAttendance.vue')
      },
      {
        path: '/companyAttendance/attendanceConfiguration',
        name: 'attendanceConfiguration',
        title: '考勤配置',
        icon: 'ios-paper',
        type: 'menu',
        component: () => import('../views/companyAttendance/attendanceConfiguration.vue')
      },
      {
        path: '/companyAttendance/uploadAttendance',
        name: 'uploadAttendance',
        title: '上传考勤',
        icon: 'ios-paper',
        type: 'menu',
        component: () => import('../views/companyAttendance/uploadAttendance.vue')
      },
      {
        path: '/companyAttendance/uploadConfiguration',
        name: 'uploadConfiguration',
        title: '上传考勤配置',
        icon: 'ios-paper',
        type: 'menu',
        component: () => import('../views/companyAttendance/uploadConfiguration.vue')
      },
      {
        path: '/employee/employee',
        name: 'employee',
        title: '职工管理',
        icon: 'ios-paper',
        type: 'menu',
        component: () => import('../views/employee/employee.vue')
      },
      {
        path: '/employee/employeeProcess',
        name: 'employeeProcess',
        title: '职工处理',
        icon: 'ios-paper',
        type: 'menu',
        component: () => import('../views/employee/employeeProcess.vue')
      },
      {
        path: '/employee/template',
        name: 'employeeTemplate',
        title: '证明文件模板管理',
        icon: 'ios-paper',
        type: 'menu',
        component: () => import('../views/employee/template.vue')
      }
    ]
  },
  {
    path: '/roast',
    name: 'roast',
    title: '吐槽',
    icon: 'ios-paper',
    type: 'menu',
    component: () => import('../views/home/homeroast.vue'),
    children: [
      {
        path: '/roast/roast',
        name: 'roast',
        title: '吐槽',
        icon: 'ios-paper',
        type: 'menu',
        component: () => import('../views/roast/roast.vue')
      },
      {
        path: '/roast/roastall',
        name: 'roast',
        title: '查看全部吐槽',
        icon: 'ios-paper',
        type: 'menu',
        component: () => import('../views/roast/roastall.vue')
      },
    ]
  },
  {
    path: '/organization',
    name: 'organization',
    title: '组织机构管理',
    icon: 'ios-paper',
    type: 'menu',
    component: () => import('../views/home/homePage.vue'),
    children: [
      {
        path: '/organization/companyApply',
        name: 'companyApply',
        title: '企业申请',
        icon: 'ios-paper',
        type: 'menu',
        component: () => import('../views/organization/companyApply.vue')
      },
      {
        path: '/organization/companyApproval',
        name: 'companyApproval',
        title: '企业审批',
        icon: 'ios-paper',
        type: 'menu',
        component: () => import('../views/organization/companyApproval.vue')
      },
      {
        path: '/organization/organizationAdd',
        name: 'organizationAdd',
        title: '新增组织机构',
        icon: 'ios-paper',
        type: 'menu',
        component: () => import('../views/organization/organizationAdd.vue')
      },
      {
        path: '/organization/organizationEdit',
        name: 'organizationEdit',
        title: '编辑组织机构',
        icon: 'ios-paper',
        type: 'menu',
        component: () => import('../views/organization/organizationEdit.vue')
      },
      {
        path: '/organization/organization',
        name: 'organization',
        title: '组织机构管理',
        icon: 'ios-paper',
        type: 'menu',
        component: () => import('../views/organization/organization.vue')
      },
      {
        path: '/organization/companyInvitationJoin',
        name: 'companyInvitationJoin',
        title: '加入企业邀请',
        icon: 'ios-paper',
        type: 'menu',
        component: () => import('../views/organization/companyInvitationJoin.vue')
      },
      {
        path: '/organization/companyInvitationApproval',
        name: 'companyInvitationApproval',
        title: '企业邀请审批',
        icon: 'ios-paper',
        type: 'menu',
        component: () => import('../views/organization/companyInvitationApproval.vue')
      },
      {
        path: '/organization/companyInvitation',
        name: 'companyInvitation',
        title: '企业邀请',
        icon: 'ios-paper',
        type: 'menu',
        component: () => import('../views/organization/companyInvitation.vue')
      },
      {
        path: '/organization/companyInvitationFeedback',
        name: 'companyInvitationFeedback',
        title: '企业邀请反馈',
        icon: 'ios-paper',
        type: 'menu',
        component: () => import('../views/organization/companyInvitationFeedback.vue')
      }
    ]
  },
  {
    path: '/accountManagement',
    name: 'accountManagement',
    title: '账户管理',
    icon: 'ios-paper',
    type: 'menu',
    component: () => import('../views/home/homePage.vue'),
    children: [
      {
        path: '/accountManagement',
        name: 'accountManagement',
        title: '账号管理',
        icon: 'ios-paper',
        type: 'menu',
        component: () => import('../views/examineAdministration/accountManagement.vue')
      },
      // {
      //   path: '/invitation',
      //   name: 'invitation',
      //   title: '企业邀请码',
      //   icon: 'ios-paper',
      //   type: 'menu',
      //   component: () => import('../views/examineAdministration/invitation.vue')
      // },
      // {
      //   path: '/examineJoin',
      //   name: 'examineJoin',
      //   title: '加入审核',
      //   icon: 'ios-paper',
      //   type: 'menu',
      //   component: () => import('../views/examineAdministration/examineJoin.vue')
      // }
    ]
  },
  {
    path: '/serviceMall',
    name: 'serviceMall',
    title: '服务商城',
    icon: 'ios-paper',
    type: 'menu',
    component: () => import('../views/home/homePage.vue'),
    children: [
      {
        path: '/serviceMall',
        name: 'serviceMall',
        title: '服务商城',
        icon: 'ios-paper',
        type: 'menu',
        component: () => import('../views/serviceMall/serviceMall.vue')
      },
      {
        path: '/serviceDetail',
        name: 'serviceDetail',
        title: '服务商城',
        icon: 'ios-paper',
        type: 'menu',
        component: () => import('../views/serviceMall/serviceDetail.vue')
      },
      {
        path: '/authentication',
        name: 'authentication',
        title: '服务商提交认证',
        icon: 'ios-paper',
        type: 'menu',
        component: () => import('../views/serviceMall/authentication.vue')
      },
      {
        path: '/productManagement',
        name: 'productManagement',
        title: '产品管理',
        icon: 'ios-paper',
        type: 'menu',
        component: () => import('../views/serviceMall/productManagement.vue')
      },
      {
        path: '/addProduct',
        name: 'addProduct',
        title: '产品新增',
        icon: 'ios-paper',
        type: 'menu',
        component: () => import('../views/serviceMall/addProduct.vue')
      },

    ]
  }
]
const staticMenuList = util.getMenuList(staticTree)
const staticMainRoutes = util.getMenuRoutes(staticTree)

// 汇总所有的路由
const staticRouters = [...staticMainRoutes, ...singleRoutes]

export {staticRouters, staticMenuList, staticTree}
